import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";
import { updateOfficeAppliancesBrand } from "../api/updateOfficeApplianceBrand";
import { IOfficeAppliancesBrand } from "../type";

const useUpdateOfficeAppliancesBrand = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (brandData: IOfficeAppliancesBrand) =>
      updateOfficeAppliancesBrand(brandData),
    {
      onSuccess: (res: any) => {
        if (res === "Duplicate") {
          toast.fire("Failed", "Brand already exists", "error");
        } else {
          toast.fire("Success", "Brand updated successfully", "success");
        }
        queryClient.invalidateQueries(["GetOfficeApplianceBrands"]);
      },
      onError: () => {
        toast.fire("Failed", "Failed to update brand", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateOfficeAppliancesBrand;
